import Snackbar, {SnackbarProps} from '@mui/material/Snackbar';

import {styled} from '@mui/material/styles';

export const CSnackbar = styled(Snackbar)<SnackbarProps>(
  (/* { theme } */) => ({
  }),
);
